import { useUserStore } from '../../stores/userStore';
import queryClient from '../../queryClient';
export function acceptLogin(user) {
  // Retain a non-secret revision even after logout, invalidating older Apple departures.
  localStorage.setItem(
    'POSTPOP_AUTH_EPOCH',
    String(Number(localStorage.getItem('POSTPOP_AUTH_EPOCH') || 0) + 1),
  );
  localStorage.setItem('POSTPOP_AUTH_TOKEN', user.token);
  queryClient.clear();
  useUserStore.setState({
    user,
    isLogin: true,
    isAdmin: user.role === 'ADMIN',
    loading: false,
    error: null,
    initialized: true,
  });
}
